import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconVar = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 18C7.90315 18 7.81196 17.9571 7.75385 17.8842L4.06154 13.2526C3.99161 13.1649 3.98037 13.0476 4.03249 12.9495C4.08461 12.8514 4.19115 12.7895 4.30769 12.7895H5.84615V7.28947C5.84615 7.1296 5.98391 7 6.15385 7H9.84615C10.0161 7 10.1538 7.1296 10.1538 7.28947V12.7895H11.6923C11.8089 12.7895 11.9154 12.8514 11.9675 12.9495C12.0196 13.0476 12.0084 13.1649 11.9385 13.2526L8.24615 17.8842C8.18805 17.9571 8.09685 18 8 18ZM15.7538 7.11579C15.812 7.0429 15.9032 7 16 7C16.0968 7 16.188 7.0429 16.2462 7.11579L19.9385 11.7474C20.0084 11.8351 20.0196 11.9524 19.9675 12.0505C19.9154 12.1486 19.8089 12.2105 19.6923 12.2105H18.1538V17.7105C18.1538 17.8704 18.0161 18 17.8462 18H14.1538C13.9839 18 13.8462 17.8704 13.8462 17.7105V12.2105H12.3077C12.1911 12.2105 12.0846 12.1486 12.0325 12.0505C11.9804 11.9524 11.9916 11.8351 12.0615 11.7474L15.7538 7.11579Z"
        />
      </svg>
    );
  }
);
